import { useState, useEffect } from "react";
import { navLinks } from "../../../mocks/bizlab";

const logoWhite =
  "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/4706e84d1179a8c47baf77d6c6236e90.png";
const logoColor =
  "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/1e9a817826cf053006c908a15441237f.png";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-20 py-4">
        {/* Logo */}
        <a href="/" className="flex items-center cursor-pointer shrink-0">
          <img
            src={scrolled ? logoColor : logoWhite}
            alt="BizLab"
            className="h-12 md:h-14 w-auto object-contain transition-all duration-300"
          />
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-slate-600 hover:text-blue-400"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => window.open("http://bizlab-demo.4-lab.com", "_blank")}
            className="px-5 py-2 text-sm font-semibold bg-blue-400 hover:bg-blue-500 text-white rounded-full transition-all duration-200 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Request Demo
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-slate-700" : "text-white"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i
            className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}
          />
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 shadow-lg">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => handleNavClick(link.href)}
                className="text-sm font-medium text-slate-700 hover:text-blue-400 text-left cursor-pointer py-2"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => window.open("http://bizlab-demo.4-lab.com", "_blank")}
              className="mt-2 px-5 py-3 text-sm font-semibold bg-blue-400 text-white rounded-full cursor-pointer whitespace-nowrap"
            >
              Request Demo
            </button>
          </div>
        </div>
      )}
    </header>
  );
}